import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";


export const startChat = async (organization_id: string, employeeId: string) => {
  try {
    const token = await getAuthToken();
    if (!token?.success || !token.data) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: `Bearer ${token.data}` };
    const data = { employee_id: employeeId };
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/teamchat/start_dm/`;

    const response = await axios.post(endpoint, data, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Data retrieval failed:", response);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error("Unexpected error occurred while starting chat:", error);
    return { success: false, data: error };
  }
};


export const fetchConversations = async (organization_id:string) => {
  const token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      const header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      const endpoint = `${baseUrl}/core/organizations/${organization_id}/teamchat/`;
      const response = await axios.get(endpoint, { headers });
      console.log('conv response', response);

      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        console.error("Data retrieval failed:", response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching conversations:", error);
    return { success: false, data: error };
  }
};

export const fetchConversation = async (organization_id:string, teamchat_id:string) => {
  const token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      const header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      const endpoint = `${baseUrl}/core/organizations/${organization_id}/teamchat/${teamchat_id}/`;
      const response = await axios.get(endpoint, { headers });

      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        console.error("Data retrieval failed:", response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching conversations:", error);
    return { success: false, data: error };
  }
};

export const fetchTeamChatMessages = async (orgId:string, conversationId: string) => {
  const token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      const header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      const endpoint = `${baseUrl}/core/organizations/${orgId}/teamchat/${conversationId}/messages/`;
      const response = await axios.get(endpoint, { headers });

      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        console.error("Data retrieval failed:", response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while fetching messages:", error);
    return { success: false, data: error };
  }
};


export const sendTeamChatMessage = async (organization_id:string, conversation_id:string, formData: FormData) => {
  const token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      const header_token = "Bearer " + token.data;
      const headers = {
        Authorization: header_token,
        "Content-Type": "multipart/form-data",
      };

      const endpoint = `${baseUrl}/core/organizations/${organization_id}/teamchat/${conversation_id}/messages/`;
      const response = await axios.post(endpoint, formData, { headers });

      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        console.error("Message send failed:", response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error occurred while sending message:", error);
    return { success: false, data: error };
  }
};
